import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import {
  HealthCareProvidersPage,
  ManageAdminsPage,
  ConsumersPage,
  OrganizationsPage,
  TestListPage,
  LoginPage,
  ForgotPasswordPage,
  ManufacturingPage,
} from './pages';
import DashboardWrapper from './pages/DashboardWrapper/DashboardWrapper';
import ProtectedRoute from './utilities/ProtectedRoute/ProtectedRoute';
import { useAuth } from './hooks/useAuth';

function PageRouter() {
  const auth = useAuth();

  return (
    <Router>
      <Routes>
        <Route
          path="*"
          element={
            <Navigate to={auth?.user?.role === 'manufacture' ? '/manufacturing' : '/'} replace />
          }
        />
        {auth?.user?.role === 'manufacture' ? (
          <Route path="/" element={<Navigate to={'/manufacturing'} replace />} />
        ) : null}
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            // eslint-disable-next-line react/jsx-wrap-multilines
            <ProtectedRoute>
              <DashboardWrapper />
            </ProtectedRoute>
          }
        >
          {auth?.user?.role === 'manufacture' ? (
            <Route path="/manufacturing" element={<ManufacturingPage />} />
          ) : (
            <>
              <Route path="/" element={<TestListPage />} />
              <Route path="/organizations" element={<OrganizationsPage />} />
              <Route path="/hcps" element={<HealthCareProvidersPage />} />
              <Route path="/admins" element={<ManageAdminsPage />} />
              <Route path="/consumers" element={<ConsumersPage />} />
              <Route path="/manufacturing" element={<ManufacturingPage />} />
            </>
          )}
        </Route>
        <Route path="/forgot_password" element={<ForgotPasswordPage />} />
      </Routes>
    </Router>
  );
}

export default PageRouter;
